// react
import { useContext, useState } from 'react';

// types
import { UserRoleWbg } from '../../../@types';
import { userRolesWbg } from '../../../@types/unions';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextUser } from '../../../App.context';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormAddIfr } from '../../forms/FormAddIfr/FormAddIfr';

// props
export interface DialogAddIfrProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogAddIfr = ({ isOpen, onClose, onSuccess }: DialogAddIfrProps) => {
	// hooks
	const { t } = useTranslation();

	// context
	const { user } = useContext(ContextUser);

	// state
	const [isLoading, setIsLoading] = useState(false);

	let cta = t('addReport');

	if (user && userRolesWbg.includes(user.role as UserRoleWbg)) {
		cta = t('addTrialReport');
	}

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: cta,
					form: 'form-add-ifr',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			onClose={onClose}
			title={{
				children: cta,
				variant: 'h3',
			}}>
			<FormAddIfr onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
